export default {
  copyright: '© {{year}} Industrielle Alliance, Assurance et services financiers inc. – iA Groupe financier. Tous droits réservés.',
};
